import set from 'lodash/set';

export const setPending = pending => state => {
  set(state, 'pending', pending);
};
